module.exports = __webpack_public_path__ + "img/delete.f3a0dc02.svg";